<ion-content>
  <app-header [title]="'Product Picture Upload'"></app-header>
  <div class="loading-container" style="padding-top:10%"  *ngIf="!loading">
      <ion-spinner></ion-spinner>
  </div>
  <ion-content class="ion-padding">
  <ion-grid >
    <form>
      <div>Upload Files</div>
<div>Select a file from your computer to upload:</div>
        <ion-row class="form-row">
          <ion-col size="12" size-md="4" class="label-cell">
            <img *ngIf="previewUrl" [src]="previewUrl" style="max-width: 100%;">
            <input type="file" (change)="onFileSelected($event)" />
          </ion-col>
        </ion-row>

    <ion-row class="ion-justify-content-center ion-padding-top">
      <ion-button color="primary" type="submit" (click)="submitForm()">Upload</ion-button>
    </ion-row>

    </form>
  </ion-grid>
</ion-content>
</ion-content>
